import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ChangeCriteriaDialogComponent } from './changeCriteriaDialog.component';

@Component({
    templateUrl: './changeLocationDialog.component.html',
    styleUrls: ['./modal.css'],
    standalone: false
})
export class ChangeLocationDialogComponent extends ChangeCriteriaDialogComponent {

    constructor(public dialogRef: MatDialogRef<ChangeCriteriaDialogComponent>) {
        super(dialogRef);
     }

}
